export function slider( node, config = {} ) {
	config = {
		wrap: '.slider__wrap',
		next: '.slider__next',
		prev: '.slider__prev',
		items: '.slider__item',
		...config
	};

	const wrap  = node.querySelector( config.wrap );
	const items = Array.from( node.querySelectorAll( config.items ) );
	const next  = node.querySelector( config.next );
	const prev  = node.querySelector( config.prev );

	if ( ! wrap || ! items ) {
		return;
	}

	let interval = null;

	const getCurrentScrollIndex = () => {
		return items.map( item => Math.abs( item.offsetLeft - wrap.scrollLeft ) ).reduce( ( closest, left, i, lefts ) => {
			return left < lefts[ closest ] ? i : closest;
		}, items.length - 1 );
	};

	const setScrollIndex = ( index, behavior = 'smooth' ) => {
		const viewable = getComputedStyle(wrap).getPropertyValue('--viewable');

		if ( index <= items.length - viewable ) {
			wrap.scrollTo( {
				left: items[ index ].offsetLeft,
				top: 0,
				behavior
			} );
		} else if ( interval > 0 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const setState = () => {
		// the last item is in view
		if ( items[ items.length - 1 ].offsetLeft - wrap.scrollLeft < wrap.offsetWidth - 200 ) {
			next.disabled = true;
		} else {
			next.removeAttribute( 'disabled' );
		}

		// first item is is view
		if ( items[0].offsetLeft - wrap.scrollLeft >= 0 ) {
			prev.disabled = true;
		} else {
			prev.removeAttribute( 'disabled' );
		}
	}

	const scrollPrev = () => {
		const index = Math.round( Math.max( getCurrentScrollIndex() - 1, 0 ) );
		setScrollIndex( index );

		if ( interval && index <= 0 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const scrollNext = () => {
		const index = Math.round( Math.min( getCurrentScrollIndex() + 1, items.length - 1 ) );
		setScrollIndex( index );

		if ( interval !== null && index === items.length - 1 ) {
			clearInterval( interval );
			interval = null;
		}
	};

	const mouseout = function() {
		this.removeEventListener( 'mouseout', mouseout );
	}

	const mousedown = function( cb, delay = 200 ) {
		if ( null !== interval ) {
			clearInterval( interval );
		}

		interval = setInterval( cb, delay );
		this.addEventListener( 'mouseup', mouseup );
		this.addEventListener( 'mouseout', mouseout );
	}

	const mouseup = function() {
		this.removeEventListener( 'mouseup', mouseup );
		window.clearInterval( interval );
		interval = null;
	}

	if ( prev ) {
		prev.addEventListener( 'mousedown', () => mousedown.call( prev, scrollPrev ) );
		prev.addEventListener( 'click', scrollPrev );
	}

	if ( next ) {
		next.addEventListener( 'mousedown', () => mousedown.call( next, scrollNext ) );
		next.addEventListener( 'click', scrollNext );
	}

	wrap.addEventListener( 'scroll', setState );
	window.addEventListener( 'resize', () => {
		setScrollIndex( getCurrentScrollIndex() );
		setState();

		if ( typeof config.resize === 'function' ) {
			config.resize();
		}
	} );
	setScrollIndex( 0 );
	setState();

	return node;
}
